import React, { useState } from 'react';
import './ScriptSourcing.css';

const ScriptSourcing = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="scriptsourcing-container">
            <h1 className="scriptsourcing-title">ScriptSourcing</h1>

            {/* Link Box */}
            <a href="https://na2.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhCz-3T2wQb4K1ClpHngU3s07J4UAbbjDjjPr0K3Q9MXaD0RyCkjkildcG--9ykZDZ4*" target="_blank" rel="noopener noreferrer" className="scriptsourcing-box">
                <div className="scriptsourcing-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="scriptsourcing-faq-section">
                <h2 className="scriptsourcing-faq-title">Frequently Asked Questions</h2>
                <div className="scriptsourcing-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`scriptsourcing-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="scriptsourcing-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="scriptsourcing-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`scriptsourcing-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ScriptSourcing;